module.exports = __webpack_public_path__ + "img/img-2-5mobile.fca694e9.webp";